<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame">
<h1 class="Poem-title" id="_idParaDest-1" lang="en-GB">S<a id="_idTextAnchor002"></a>ilent Beauties</h1>
<p class="Verse-first" lang="en-GB">The sun rose steadily in the distance,</p>
<p class="Verse-main" lang="en-GB">I sat as it illuminated the sky with its golden brilliance.</p>
<p class="Verse-main" lang="en-GB">The mountains stood tall and marvelled at his golden hue, while the sun</p>
<p class="Verse-main" lang="en-GB">Painted them in it.</p>
<p class="Verse-new" lang="en-GB">I sat and watched in awe as wildlife sprang to life around me.</p>
<p class="Verse-main" lang="en-GB">The birds awoke and sang their songs</p>
<p class="Verse-main" lang="en-GB">Of happiness and new beginnings, songs of joy</p>
<p class="Verse-main" lang="en-GB">And adventure and songs of melancholy too.</p>
<p class="Verse-main" lang="en-GB">I sat and took in the smells of the morning air and the wonders of the sky,</p>
<p class="Verse-main" lang="en-GB">Striped with pastels.</p>
<p class="Verse-main" lang="en-GB">Blues, yellows, pinks and greys too.</p>
<p class="Verse-new" lang="en-GB">And I hoped that each day would have such</p>
<p class="Verse-main" lang="en-GB">A brilliant positivity,</p>
<p class="Verse-main" lang="en-GB">But they never do;</p>
<p class="Verse-main" lang="en-GB">And that’s what makes this day and this scenery a treasure,</p>
<p class="Verse-main" lang="en-GB">Because nothing will ever be identical to it.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781035801855_EPUB-5.vue?47b7b380